import { useMemo } from "react";
import { deviceDetector } from "@ospweb/sdk-ui";

import {
  resolveCompletePlansFromData,
  type CompletePlansByType,
} from "./memberPlansData";
import { MemberProduct, PayChannel } from "../features/api/memberApi";

export const useMemberCompletePlans = ({
  data,
}: {
  data?: MemberProduct[];
}): CompletePlansByType => {
  const isApp = deviceDetector.isApp();
  const payChannel = deviceDetector.isIOSApp()
    ? PayChannel.APPLE_IAP
    : PayChannel.GOOGLE_IAP;

  return useMemo(
    () =>
      resolveCompletePlansFromData(data ?? [], {
        isApp,
        payChannel,
      }),
    [data, isApp, payChannel],
  );
};
